import { render } from "./AniMateurs.vue?vue&type=template&id=b3865e2e&scoped=true&ts=true"
import script from "./AniMateurs.vue?vue&type=script&lang=ts"
export * from "./AniMateurs.vue?vue&type=script&lang=ts"

import "./AniMateurs.vue?vue&type=style&index=0&id=b3865e2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3865e2e"]])

export default __exports__